import script from "./resetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./resetPassword.vue?vue&type=script&setup=true&lang=js"

import "./resetPassword.vue?vue&type=style&index=0&id=66870c40&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66870c40"]])

export default __exports__